/* Frame — кадр общего живого канала платформы (спека §3.1), закрытый список типов. */
export function isFrame(value) {
    if (!value || typeof value !== "object")
        return false;
    const f = value;
    return typeof f.type === "string" && typeof f.subject === "string";
}
